export const imagesBat = {
  "pr1-terasse": {
    "id": "pr1-terasse",
    "cover": "https://cv-api-omega.vercel.app/bat/pr1/pr1-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr1/pr1-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr1/pr1-6.jpg"
    ]
  },
  "renovation_totale": {
    "id": "renovation_totale",
    "cover": "https://cv-api-omega.vercel.app/bat/pr2/pr2-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-8.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-11.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-11.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-11.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-11.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-12.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-12.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-12.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-13.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-13.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-13.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-13.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-14.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-14.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-14.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-14.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-15.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-15.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-15.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-15.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-16.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-16.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-16.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-16.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-17.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-17.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-17.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-17.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-18.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-18.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-18.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-18.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-19.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-19.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-19.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-19.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-20.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-20.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-20.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-20.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-21.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-21.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-21.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-21.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-22.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-22.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-22.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-22.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-23.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-23.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-23.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-23.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-24.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-24.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-24.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-24.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-25.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-25.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-25.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-25.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-26.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-26.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-26.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-26.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-27.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-27.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-27.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-27.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-28.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-28.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-28.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-28.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-29.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-29.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-29.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-29.jpg"
    ]
  },
  "renovation_maison": {
    "id": "renovation_maison",
    "cover": "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-22.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-22.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-22.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-22.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-22.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-0.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-0.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-0.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-0.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-8.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-11.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-11.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-11.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-11.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-12.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-12.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-12.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-13.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-13.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-13.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-13.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-14.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-14.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-14.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-14.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-15.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-15.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-15.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-15.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-16.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-16.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-16.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-16.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-17.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-17.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-17.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-17.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-18.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-18.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-18.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-18.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-19.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-19.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-19.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-19.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-20.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-20.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-20.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-20.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-21.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-21.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-21.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-21.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-23.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-23.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-23.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-23.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-24.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-24.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-24.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-24.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-25.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-25.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-25.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-25.jpg"
    ]
  },
  "consolidation_maison": {
    "id": "consolidation_maison",
    "cover": "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-8.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-11.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-11.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-11.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-11.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-12.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-12.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-12.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-13.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-13.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-13.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-13.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-14.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-14.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-14.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-14.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-15.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-15.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-15.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-15.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-16.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-16.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-16.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-16.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-17.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-17.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-17.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-17.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-18.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-18.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-18.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-18.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-19.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-19.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-19.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-19.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-20.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-20.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-20.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-20.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-21.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-21.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-21.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-21.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-22.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-22.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-22.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-22.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-23.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-23.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-23.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-23.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-24.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-24.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-24.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-24.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-25.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-25.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-25.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-25.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-26.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-26.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-26.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-26.jpg"
    ]
  },
  "ouvertures": {
    "id": "ouvertures",
    "cover": "https://cv-api-omega.vercel.app/bat/pr3/pr3-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-8.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-10.jpg"
    ]
  },
  "extension": {
    "id": "extension",
    "cover": "https://cv-api-omega.vercel.app/bat/pr4/pr4-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-8.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-11.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-11.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-11.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-11.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-12.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-12.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-12.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-13.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-13.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-13.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-13.jpg",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-14.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-14.webp",
      "https://cv-api-omega.vercel.app/bat/pr4/pr4-14.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr4/pr4-14.jpg"
    ]
  },
  "isolation-placo": {
    "id": "isolation-placo",
    "cover": "https://cv-api-omega.vercel.app/bat/pr5/pr5-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr5/pr5-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr5/pr5-4.jpg"
    ]
  },
  "assainissement": {
    "id": "assainissement",
    "cover": "",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-8.jpg"
    ]
  }
};
